import type { AnalyticsPromoInstallAppBannerStoreDestination } from '@setplex/tria-api'

// TODO maybe should redo as we receive platform with links from backend
export const APP_STORE_URL = 'https://apps.apple.com/app/uvotv/id6469518760'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.uvotv.android&pli=1'
/** Amazon Appstore listing (Fire tablets and other Amazon Android devices) */
export const AMAZON_STORE_URL =
  'https://www.amazon.com/UVO-Entertainment-LLC-UVOtv-International/dp/B0CWJCF998'

function isIosMobileOrTablet(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  if (/iPhone|iPod|iPad/i.test(ua)) return true
  // iPadOS 13+ Safari often reports as desktop Mac
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}

/** Android TV / Fire TV / stick class UAs — not phones or tablets. */
function isAndroidLivingRoomUserAgent(ua: string): boolean {
  if (/Android TV/i.test(ua)) return true
  if (/Smart-TV|SmartTV/i.test(ua)) return true
  // Amazon Fire TV / Stick (AFT*); Fire tablets use KF* model ids
  if (/;\s*AFT[A-Z0-9]+\s+Build/i.test(ua)) return true
  return false
}

/**
 * Install banner: iOS / iPadOS phones & tablets, Android phones & tablets, Fire OS phones & tablets.
 * Excludes desktop browsers, TV/living-room devices, and other platforms.
 */
export function isPromoBannerEligibleDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent

  if (isIosMobileOrTablet()) return true

  if (!/android/i.test(ua)) return false
  if (isAndroidLivingRoomUserAgent(ua)) return false

  return true
}
function isAmazonAndroidTabletOrPhone(ua: string): boolean {
  const normalizedUA = ua || ''

  if (!/android/i.test(normalizedUA)) return false

  if (isAndroidLivingRoomUserAgent(normalizedUA)) return false

  return (
    // Amazon Silk browser (strong signal)
    /Silk\//i.test(normalizedUA) ||
    // Explicit Amazon branding (sometimes present)
    /\bAmazon\b/i.test(normalizedUA) ||
    // Kindle / Fire device model identifiers (KF*)
    /\bKF[A-Z0-9]{2,6}\b/i.test(normalizedUA) ||
    // Fire OS / Kindle Fire hints (less common but useful)
    /Kindle Fire/i.test(normalizedUA) ||
    /Fire OS/i.test(normalizedUA) ||
    // Some Fire devices include Build tag with KF model
    /;\s*KF[A-Z0-9]+\b.*Build/i.test(normalizedUA)
  )
}

/**
 * Returns App Store, Play Store, or Amazon Appstore URL based on user agent.
 * Used when deep link fails (app not installed) — redirect to store.
 */
export function getStoreUrl(): string {
  if (typeof navigator === 'undefined') return APP_STORE_URL
  const ua = navigator.userAgent
  if (/iPhone|iPod|iPad/i.test(ua)) return APP_STORE_URL
  // iPadOS 13+ Safari often reports as desktop Mac (MacIntel), but with touch support (maxTouchPoints > 1),
  // so treat as iPad and return the App Store URL.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return APP_STORE_URL
  }
  if (isAmazonAndroidTabletOrPhone(ua)) return AMAZON_STORE_URL
  if (/android/i.test(ua)) return PLAY_STORE_URL
  return APP_STORE_URL
}

export function getInstallBannerStoreDestination(): AnalyticsPromoInstallAppBannerStoreDestination {
  const url = getStoreUrl()
  if (url === AMAZON_STORE_URL) return 'amazon_store'
  if (url === PLAY_STORE_URL) return 'google_play_store'
  return 'app_store'
}
